export default () => ({
  messages: [],
});
